import { useCallback, useEffect, useState } from 'react';

import { isInViewport } from 'utils/isInViewport';
import { UseElementInViewProps } from './types';

const useElementInView = ({ elementRef, bottom = 0 }: UseElementInViewProps) => {
  const [isElementInView, setIsElementInView] = useState(true);

  const handleScroll = useCallback(() => {
    setIsElementInView(isInViewport(elementRef.current, bottom));
  }, [bottom, elementRef]);

  useEffect(() => {
    if (!elementRef.current) {
      setIsElementInView(true);
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [elementRef, handleScroll, isElementInView]);

  return {
    isElementInView,
  };
};
export default useElementInView;
